import React from 'react'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import {
  type DateTimePickerProps,
  DateTimePicker as SharedDateTimePicker,
} from 'src/editor/shared/ui-lib/date-time-picker'

const DateTimePicker = (props: DateTimePickerProps) => {
  return (
    <OptionWrapper>
      <SharedDateTimePicker {...props} />
    </OptionWrapper>
  )
}

export default DateTimePicker
